import {
  AllProductsIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  GrowIcon,
  GummyIcon,
  JaneGoldIcon,
  MerchIcon,
  PrerollIcon,
  StarFilledIcon,
  TagFilledIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ColorKey, IconComponent } from '@iheartjane/reefer';
import type { MenuTab } from '@iheartjane/types';

import { DEFAULT_CATEGORY_IMAGES } from './assets';

interface MenuCategory {
  Icon: IconComponent;
  iconColor?: ColorKey;
  image?: string;
}

export const MENU_CATEGORY_TABS: Record<MenuTab, MenuCategory> = {
  featured: {
    Icon: StarFilledIcon,
    iconColor: 'primary',
  },
  specials: {
    Icon: TagFilledIcon,
    iconColor: 'info',
  },
  brand_specials: {
    Icon: JaneGoldIcon,
    iconColor: 'gold',
  },
  flower: {
    Icon: FlowerIcon,
    image: DEFAULT_CATEGORY_IMAGES.flower,
  },
  edible: {
    Icon: GummyIcon,
    image: DEFAULT_CATEGORY_IMAGES.edible,
  },
  'pre-roll': {
    Icon: PrerollIcon,
    image: DEFAULT_CATEGORY_IMAGES['pre-roll'],
  },
  extract: {
    Icon: ExtractIcon,
    image: DEFAULT_CATEGORY_IMAGES.extract,
  },
  tincture: {
    Icon: TinctureIcon,
    image: DEFAULT_CATEGORY_IMAGES.tincture,
  },
  topical: {
    Icon: TopicalIcon,
    image: DEFAULT_CATEGORY_IMAGES.topical,
  },
  vape: {
    Icon: VapeIcon,
    image: DEFAULT_CATEGORY_IMAGES.vape,
  },
  merch: {
    Icon: MerchIcon,
    image: DEFAULT_CATEGORY_IMAGES.merch,
  },
  gear: {
    Icon: GearIcon,
    image: DEFAULT_CATEGORY_IMAGES.gear,
  },
  grow: {
    Icon: GrowIcon,
    image: DEFAULT_CATEGORY_IMAGES.grow,
  },
  'all-products': {
    Icon: AllProductsIcon,
  },
};
